var _circle, _path, _path2, _g, _path3, _path4, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinProfileBlast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 101,
    viewBox: "0 0 104 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4197_767)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4375,
    cy: 45.4375,
    r: 41.4375,
    fill: "#D9D9D9",
    fillOpacity: 0.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.125 14.5625C95.125 9.28128 90.8437 5 85.5625 5C80.2813 5 76 9.28128 76 14.5625C76 19.8437 80.2813 24.125 85.5625 24.125C90.8437 24.125 95.125 19.8437 95.125 14.5625Z",
    fill: "#60A5FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4197_767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 5,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.125 14.5625C95.125 9.28128 90.8437 5 85.5625 5C80.2813 5 76 9.28128 76 14.5625C76 19.8437 80.2813 24.125 85.5625 24.125C90.8437 24.125 95.125 19.8437 95.125 14.5625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4197_767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.283 20.4027C92.283 20.4027 89.1865 23.4015 85.8453 23.4015C82.5041 23.4015 79.1094 20.5731 79.1094 20.5731C79.5662 17.8527 81.0346 16.2678 85.0186 16.0621C90.0418 15.8018 91.8275 17.7819 92.283 20.4027Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5313 15.4788C84.6138 15.4742 83.7355 15.1064 83.0884 14.456C82.4414 13.8056 82.0781 12.9255 82.0781 12.008C82.0784 11.5496 82.1696 11.0958 82.3464 10.6728C82.5233 10.2499 82.7822 9.8662 83.1083 9.54398C83.4344 9.22176 83.8211 8.9674 84.2461 8.79562C84.6711 8.62383 85.126 8.53804 85.5844 8.54319C86.5018 8.55356 87.3778 8.92713 88.0204 9.58206C88.663 10.237 89.0198 11.1199 89.0127 12.0374C89.0049 12.9547 88.6344 13.8315 87.982 14.4764C87.3297 15.1213 86.4485 15.4817 85.5313 15.4788Z",
    fill: "#E9E9E9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80.5C25 75.8056 21.1944 72 16.5 72C11.8056 72 8 75.8056 8 80.5C8 85.1944 11.8056 89 16.5 89C21.1944 89 25 85.1944 25 80.5Z",
    fill: "#C084FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4197_767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 72,
    width: 18,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 80.875C25.5 76.1806 21.6944 72.375 17 72.375C12.3056 72.375 8.5 76.1806 8.5 80.875C8.5 85.5694 12.3056 89.375 17 89.375C21.6944 89.375 25.5 85.5694 25.5 80.875Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4197_767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4872 85.6913C22.4872 85.6913 19.7348 88.3569 16.7648 88.3569C13.7948 88.3569 10.7773 85.8427 10.7773 85.8427C11.1835 83.4247 12.4887 82.0159 16.03 81.833C20.495 81.6016 22.0823 83.3617 22.4872 85.6913Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4874 81.3137C15.6719 81.3095 14.8912 80.9826 14.316 80.4045C13.7408 79.8263 13.418 79.044 13.418 78.2285C13.4182 77.821 13.4993 77.4176 13.6565 77.0416C13.8137 76.6657 14.0438 76.3246 14.3337 76.0382C14.6235 75.7518 14.9673 75.5257 15.3451 75.373C15.7229 75.2203 16.1272 75.1441 16.5346 75.1486C17.3502 75.1579 18.1288 75.4899 18.7 76.0721C19.2712 76.6542 19.5883 77.439 19.582 78.2546C19.5751 79.0699 19.2458 79.8494 18.6659 80.4226C18.086 80.9958 17.3028 81.3162 16.4874 81.3137Z",
    fill: "#E9E9E9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4197_767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6875 35.5703C22.7556 35.5703 22 36.3259 22 37.2578V50.4295C22 51.3615 22.7556 52.117 23.6875 52.117C24.6195 52.117 25.375 51.3615 25.375 50.4295V37.2578C25.375 36.3259 24.6195 35.5703 23.6875 35.5703Z",
    fill: "#F18181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4481 25.7266H52.4271C51.4952 25.7266 50.7396 26.4821 50.7396 27.4141V28.9385L28.1414 35.6397C27.425 35.8521 26.9336 36.5105 26.9336 37.2575V50.4229C26.9332 50.5073 26.9413 50.5923 26.9539 50.6776C26.9561 50.6933 26.9584 50.7091 26.9611 50.7246C26.9737 50.7944 26.989 50.8641 27.0108 50.9334L31.7946 66.2111C32.0205 66.9327 32.6863 67.3949 33.4045 67.3949C33.5712 67.3949 33.7409 67.3699 33.9085 67.3175L40.8748 65.1392C41.3021 65.0056 41.6587 64.7076 41.8662 64.3112C42.0738 63.9147 42.1152 63.4519 41.9816 63.0246L39.611 55.449L50.7394 58.7498V60.274C50.7394 61.2059 51.4949 61.9615 52.4269 61.9615H59.4479C60.3799 61.9615 61.1354 61.2059 61.1354 60.274V27.4141C61.1356 26.4821 60.3801 25.7266 59.4481 25.7266ZM38.2567 62.4216L34.5113 63.5928L31.1781 52.9476L35.7128 54.2925L38.2567 62.4216ZM37.5441 51.3157C37.5394 51.3143 37.5344 51.3128 37.5297 51.3114L30.3089 49.1696V38.5173L50.7398 32.4589V55.2296L37.5441 51.3157ZM57.7606 58.5867H54.1146V57.4902V30.1983V29.1018H57.7606V58.5867Z",
    fill: "#F18181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6157 53.2909L65.3139 49.6394C64.48 49.2229 63.4666 49.5602 63.0497 50.394C62.6328 51.2277 62.9707 52.2413 63.8043 52.6582L71.1061 56.3098C71.3485 56.4311 71.6059 56.4882 71.8597 56.4882C72.4787 56.4882 73.0747 56.1465 73.3703 55.5552C73.7871 54.7215 73.4491 53.7079 72.6157 53.2909Z",
    fill: "#F18181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5604 38.2262C64.8139 38.2262 65.0716 38.1689 65.3137 38.0476L72.6157 34.3965C73.4493 33.9795 73.7873 32.9661 73.3703 32.1325C72.9536 31.2988 71.9398 30.9609 71.1064 31.3778L63.8043 35.0289C62.9707 35.4459 62.6328 36.4593 63.0497 37.2929C63.3453 37.8844 63.9414 38.2262 64.5604 38.2262Z",
    fill: "#F18181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.437 42.1562H67.3399C66.4079 42.1562 65.6523 42.9118 65.6523 43.8438C65.6523 44.7757 66.4079 45.5313 67.3399 45.5313H73.437C74.369 45.5313 75.1245 44.7757 75.1245 43.8438C75.1245 42.9116 74.369 42.1562 73.437 42.1562Z",
    fill: "#F18181"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4197_767",
    x: 0,
    y: 0,
    width: 103.125,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4197_767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4197_767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4197_767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.125,
    height: 53.125,
    fill: "white",
    transform: "translate(22 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinProfileBlast);
export default __webpack_public_path__ + "static/media/SpinProfileBlast.3cbae288a6dc23ce63c332855ee61ae3.svg";
export { ForwardRef as ReactComponent };